// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container__3aCSW","image":"styles__image__14tvH","title":"styles__title__3E788","cost":"styles__cost__paIsb","details":"styles__details__2QqJD","bottom":"styles__bottom__2c3nA","sameHeight":"styles__sameHeight__3Y72x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductVariant/styles.scss
// module id = 409
// module chunks = 0